<template>
	<div class="register_form_box">
		<div class="container">
			<v-logo></v-logo>
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'register_msg_yz',
		data() {
			return {
				user: {
					mobile: "",
					password: "",
					yzm: ""
				}
			}
		},
		mounted: function() {
			this.$nextTick(function() {
				this.$inputFocus(".input_focus");
				this.fleshVerify();
			})
		},
		methods: {
			fleshVerify() {
				var formData = Math.random();
				//重载验证码
				this.$http.post('/zklccloud/captcha.jpg', {
					formData
				}, {
					emulateJSON: true
				}).then(function(m) {
					var verify = document.getElementById('verifyImg1');
					verify.setAttribute('src', '/zklccloud/captcha.jpg?' + Math.random());
				})
			},
			checkMobile() {
				var mob = $.trim(this.user.mobile);
				var isMob = /^(?:13\d|14\d|15\d|18\d|17\d)\d{5}(\d{3}|\*{3})$/;
				if(!isMob.test(mob)) {
					$(".kfzreg-hide").removeClass("kfzreg-hide");
					$(".regcontent").text('请输入正确的手机号码');
					return;
				} else {
					$(".regcontent").text('');
					var formData = JSON.stringify(this.user);
					this.$http.post('/zklccloud/register/checkMob', formData, {
						emulateJSON: true
					}).then(function(m) {
						if(m.body.resultCode != 0) {
							$(".kfzreg-hide").removeClass("kfzreg-hide");
							$(".regcontent").text('您输入的手机号已经被注册过了,请重新输入');
							return;
						}
					})
				}

			},
			reg() {
				var pwd = $.trim(this.user.password);
				var mob = $.trim(this.user.mobile);
				var yzm = $.trim(this.user.yzm);
				var isMob = /^(?:13\d|14\d|15\d|18\d|17\d)\d{5}(\d{3}|\*{3})$/;
                var ispwd=/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{8,}$/;

				if(mob == "") {
					$(".kfzreg-hide").removeClass("kfzreg-hide");
					$(".regcontent").text('手机号不能为空');
					this.fleshVerify();
					return;
				} else if(!isMob.test(mob)) {
					$(".kfzreg-hide").removeClass("kfzreg-hide");
					$(".regcontent").text('请输入正确的手机号码');
					return;
				}
				if(pwd == "") {
					$(".kfzreg-hide").removeClass("kfzreg-hide");
					$(".regcontent").text('密码不能为空');
					this.fleshVerify();
					return;
				} else if(!ispwd.test(pwd)) {
					$(".kfzreg-hide").removeClass("kfzreg-hide");
					$(".regcontent").text('密码由8位以上数字、字母和特殊符号组成,请重新输入');
					this.fleshVerify();
					return;
				}
				var yzm = $.trim(this.user.yzm);
				if(yzm == "") {
					$(".kfzreg-hide").removeClass("kfzreg-hide");
					$(".regcontent").text('验证码不能为空');
					this.fleshVerify();
					return;
				}


				var time1 = new Date();
				time1.setHours(0); //获取当前小时数(0-23)
				time1.setMinutes(0); //获取当前分钟数(0-59)
				time1.setSeconds(0); //获取当前秒数(0-59)
				time1.setMilliseconds(0); //获取当前毫秒数(0-999)
				var startTime = time1;
				var time2 = new Date();
				time2.setHours(23); //获取当前小时数(0-23)
				time2.setMinutes(59); //获取当前分钟数(0-59)
				time2.setSeconds(59); //获取当前秒数(0-59)
				time2.setMilliseconds(999); //获取当前毫秒数(0-999)
				var endTime = time2;
				this.user.startTime = startTime.valueOf();
				this.user.endTime = endTime.valueOf();
				var formData = JSON.stringify(this.user);
				this.$http.post('/zklccloud/register/sendMes', formData, {
					emulateJSON: true
				}).then(function(m) {
					if(m.body.content.switch == 1) {
						$(".kfzreg-hide").removeClass("kfzreg-hide");
						$(".regcontent").text('当天最多发送5次验证码,已超过限制！');
						this.fleshVerify();
						return;
					}
					if(m.body.content.repeat == 1) {
						$(".kfzreg-hide").removeClass("kfzreg-hide");
						$(".regcontent").text('您输入的手机号已经被注册过了,请重新输入');
						return;
					}
					if(m.body.resultCode == 0) {
						var mobile = m.body.content.mobile;
						var password = m.body.content.password;
						var memo = m.body.content.memo;
						this.$router.push({
							name: 'register_yz',
							params: {
								mobile: mobile,
								password: password,
								memo: memo
							}
						});
					} else if(m.body.resultCode == -2) {
						$(".kfzreg-hide").removeClass("kfzreg-hide");
						$(".regcontent").text('发送验证码失败,请联系管理员!');
						this.fleshVerify();
					} else {
						$(".kfzreg-hide").removeClass("kfzreg-hide");
						$(".regcontent").text('您输入的验证码有误,请重新输入');
						this.fleshVerify();
					}

				})
			}
		}
	}
</script>

<style scoped>
	.register_form_box {
		min-height: 100%;
		background: url(img/bg-register.png) no-repeat center center;
		-webkit-background-size: cover;
		background-size: cover;
	}

	.register_box {
		width: 340px;
		padding: 10px;
		margin: auto;
	}
</style>



// WEBPACK FOOTER //
// register_index.vue?51f244ea